import VaRPanel from "@/components/risk/VaRPanel";
import RiskLensesPanel from "@/components/risk/RiskLensesPanel";

export default function RVaR() {
  return (
    <div className="space-y-6">
      <VaRPanel range="R" />
      <RiskLensesPanel range="R" />
    </div>
  );
}
